import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import "./Auth.css";
import Logo from "../Images/logoblack.svg";

import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import {
  collection,
  doc,
  getDocs,
  getFirestore,
  limit,
  query,
  setDoc,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { app } from "../firebase";

function Register() {
  const smsUrl = "https://us-central1-dropoff-mtaani.cloudfunctions.net/api/send-sms";
  const auth = getAuth(app);
  const db = getFirestore(app);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    full_name: "",
    businessName: "",
    userphone: "",
    city: "",
    aboutBusiness: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const validateForm = () => {
    if (
      !formData.full_name.trim() ||
      !formData.userphone.trim() ||
      !formData.email.trim() ||
      !formData.password
    ) {
      swal("Missing Fields", "Please fill all required fields.", "warning");
      return false;
    }

    if (!/^\d+$/.test(formData.userphone.trim())) {
      swal("Invalid Phone", "Phone number should contain digits only.", "warning");
      return false;
    }

    if (formData.password.length < 6) {
      swal("Weak Password", "Password must be at least 6 characters.", "warning");
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      swal("Password Error", "Passwords do not match.", "warning");
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const cred = await createUserWithEmailAndPassword(
        auth,
        formData.email.trim(),
        formData.password
      );

      const uid = cred.user.uid;
      const normalizedEmail = formData.email.trim().toLowerCase();
      const payload = {
        uid,
        userType: "client",
        full_name: formData.full_name.trim(),
        businessName: formData.businessName.trim(),
        userphone: formData.userphone.trim(),
        city: formData.city.trim(),
        aboutBusiness: formData.aboutBusiness.trim(),
        email: normalizedEmail,
        lastTimeLocationUpdate: Timestamp.now(),
      };

      const existingClientQuery = query(
        collection(db, "clients"),
        where("email", "==", normalizedEmail),
        limit(1)
      );
      const existingClientSnap = await getDocs(existingClientQuery);

      if (!existingClientSnap.empty) {
        const existingClient = existingClientSnap.docs[0];
        await updateDoc(doc(db, "clients", existingClient.id), {
          ...payload,
          signupdate: existingClient.data().signupdate || Timestamp.now(),
        });
      } else {
        await setDoc(doc(db, "clients", uid), {
          ...payload,
          signupdate: Timestamp.now(),
        });
      }

      try {
        await axios.post(
          smsUrl,
          {
            mobile: formData.userphone.trim(),
            message: `Welcome to Dropoff Mtaani, ${formData.full_name.trim()}. Your customer account is ready. You can now place orders in your portal.`,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      } catch (smsError) {
        // Account creation should not fail if SMS provider is temporarily unavailable.
        console.error("Welcome SMS failed:", smsError);
      }

      swal("Success", "Account created successfully.", "success");
      navigate("/my-orders");
    } catch (error) {
      console.error("Registration error:", error);
      swal("Registration Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authMain">
      <div className="authLeft" />
      <div className="authRight">
        <div>
          <Link to="/">
            <img src={Logo} alt="Dropoff Mtaani" className="authRightLogo" />
          </Link>
          <p className="text-muted">Create your customer account to place orders.</p>
        </div>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mt-2">
            <Form.Label>Full Name</Form.Label>
            <Form.Control
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>Business Name</Form.Label>
            <Form.Control
              type="text"
              name="businessName"
              value={formData.businessName}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="text"
              name="userphone"
              value={formData.userphone}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>About Business</Form.Label>
            <Form.Control
              type="text"
              name="aboutBusiness"
              value={formData.aboutBusiness}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Button type="submit" className="mt-3 btnLogin w-100" disabled={loading}>
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Creating Account...
              </>
            ) : (
              "Create Account"
            )}
          </Button>
        </Form>

        <div className="signuptextCont mt-3">
          <h6 className="text-muted">
            Already have an account? <Link to="/login">Sign In</Link>
          </h6>
        </div>
      </div>
    </div>
  );
}

export default Register;
